/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostApiAuthBarberLoginMutationRequest, PostApiAuthBarberLoginMutationResponse, PostApiAuthBarberLogin400, PostApiAuthBarberLogin401, PostApiAuthBarberLogin409, PostApiAuthBarberLogin423 } from "../entities/PostApiAuthBarberLogin";

function getPostApiAuthBarberLoginUrl() {
  const res = { method: 'POST', url: `/api/auth/barber/login` as const }
  return res
}

/**
 * @description Авторизация мастера по PIN-коду (6 цифр)
 * @summary Вход мастера
 * {@link /api/auth/barber/login}
 */
export async function postApiAuthBarberLogin(data: PostApiAuthBarberLoginMutationRequest, config: Partial<RequestConfig<PostApiAuthBarberLoginMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PostApiAuthBarberLoginMutationResponse, ResponseErrorConfig<PostApiAuthBarberLogin400 | PostApiAuthBarberLogin401 | PostApiAuthBarberLogin409 | PostApiAuthBarberLogin423>, PostApiAuthBarberLoginMutationRequest>({ method : "POST", url : getPostApiAuthBarberLoginUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}